(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lion-choice"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lion-choice'))customElements.define('lion-choice',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.data=JSON.parse(this.querySelector('[data-lion-data]').textContent);this.querySelector('[data-lion-enhanced]').hidden=false;this.querySelector('[data-lion-fallback]').hidden=true;this.querySelector('[data-lion-fallback] select').disabled=true;this.querySelector('[data-lion-id]').disabled=false;this.addEventListener('change',e=>{if(e.target.matches('[data-size-value]'))this.querySelector('[data-option][hidden]').value=e.target.value;this.update();});this.update();}
    update(){const options=Array.from(this.querySelectorAll('[data-option]')).map(x=>x.value);this.variant=this.data.variants.find(v=>v.options.every((o,i)=>!options[i]||o===options[i]));const size=this.querySelector('[data-property-size]');this.valid=options.every(Boolean)&&!!this.variant?.available&&(!size||!!size.value);this.querySelector('[data-lion-id]').value=this.variant?.id||'';this.dispatchEvent(new CustomEvent('lion:choice',{bubbles:true,detail:{variant:this.variant,valid:this.valid,data:this.data}}));}
    selection(){if(!this.valid)return null;const size=this.querySelector('[data-property-size]');return {id:this.variant.id,quantity:1,...(size?{properties:{size:size.value}}:{})};}
  });
  } catch(e) { console.error(e); }
})();

})();
